import { SaveUserDataProperties, UserProperties } from '../../redux/API/userAPIProperties';

export enum ACTIONS {
	setState = 'setState',
	setId = 'setId',
	setFirstName = 'setFirstName',
	setLastName = 'setLastName',
	setFullName = 'setFullName',
	setEmail = 'setEmail',
	setPhoneNumber = 'setPhoneNumber',
	setAddress = 'setAddress',
	setRoleId = 'setRoleId',
	setAuthorizationType = 'setAuthorizationType',
	setInsurances = 'setInsurances',
	setActive = 'setActive',
	setCaseCoordinator = 'setCaseCoordinator',
	setMBHId = 'setMBHId',
	setDOEId = 'setDOEId',
	setCanBeAssignedToClient = 'setCanBeAssignedToClient',
	setBranchIds = 'setBranchIds',
}

export const initialState: SaveUserDataProperties = {
	firstName: '',
	lastName: '',
	fullName: '',
	phoneNumber: '',
	address: '',
	email: '',
	roleId: '',
	authorizationType: null,
	insurances: [],
	isDeactivated: false,
	isCaseCoordinator: false,
	mbhId: '',
	doeId: '',
	canBeAssignedToClient: true,
	branchIds: [],
};

export interface ActionProperties {
	payload: any;

	type: keyof typeof ACTIONS;
}

export const adminReducer = (state: UserProperties, action: ActionProperties) => {
	const { type, payload } = action;

	switch (type) {
		case ACTIONS.setState:
			return {
				...state,
				...payload,
			};
		case ACTIONS.setId:
			return {
				...state,
				id: payload,
			};
		case ACTIONS.setFirstName:
			return {
				...state,
				firstName: payload,
			};
		case ACTIONS.setFullName:
			return {
				...state,
				fullName: payload,
			};
		case ACTIONS.setLastName:
			return {
				...state,
				lastName: payload,
			};
		case ACTIONS.setEmail:
			return {
				...state,
				email: payload,
			};
		case ACTIONS.setPhoneNumber:
			return {
				...state,
				phoneNumber: payload,
			};
		case ACTIONS.setAddress:
			return {
				...state,
				address: payload,
			};
		case ACTIONS.setActive:
			return {
				...state,
				isDeactivated: payload,
			};
		case ACTIONS.setCaseCoordinator:
			return {
				...state,
				isCaseCoordinator: payload,
			};
		case ACTIONS.setRoleId:
			return {
				...state,
				roleId: payload,
			};
		case ACTIONS.setAuthorizationType:
			return {
				...state,
				authorizationType: payload,
			};
		case ACTIONS.setInsurances:
			return {
				...state,
				insurances: payload,
			};
		case ACTIONS.setMBHId:
			return {
				...state,
				mbhId: payload,
			};
		case ACTIONS.setDOEId:
			return {
				...state,
				doeId: payload,
			};
		case ACTIONS.setCanBeAssignedToClient:
			return {
				...state,
				canBeAssignedToClient: payload,
			};
		case ACTIONS.setBranchIds:
			return {
				...state,
				branchIds: payload,
			};
		default:
			return state;
	}
};
